import axios, { AxiosResponse } from 'axios';

export const url = '/services/isnaportal/open-api/find-nds-payer/search-in-knp';
//?clientRecaptchaResponse=${token}
export const getTaxPayerInfo = (request: any, token?: any): Promise<AxiosResponse> => {
    return axios.post(`${url}`, request);
};
